import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { Box, Divider, Typography } from '@mui/material';

type Props = {
  bio: string;
};

const ProfileBio = ({ bio }: Props) => {
  const { t } = useIntlTranslations('profileBio');
  return (
    <>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ mb: 2.5 }}>
        <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1.5, color: '#132847' }}>
          {t('bio')}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: '#132847', lineHeight: 1.8, whiteSpace: 'pre-wrap' }}
        >
          {bio}
        </Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />
    </>
  );
};

export default ProfileBio;
